import React from 'react';

function Numeric(props) {
    const handleChange = (name, value) => {
        if (value == '0') {
            return;
        }
        props.onChange(name, value);
    }
    const handleKeyPress = (event) => {
        const text = (props.value || '') + '';
        if (props.allowDecimals && event.which == 46) {
            if (text && text.indexOf('.') >= 0) {
                event.preventDefault();
                event.stopPropagation();
            }
            return true;
        } else if (props.allowNegatives && event.which == 45) {
            if ((text && text.indexOf('-') >= 0) || (event.target && event.target.selectionStart > 0)) {
                event.preventDefault();
                event.stopPropagation();
            }
            return true;
        } else if (!props.allowZero && event.which == 48 && text + '0' == '0') {
            event.preventDefault();
            event.stopPropagation();
            return true;
        }
        if (event.which < 48 || event.which > 57) {
            event.preventDefault();
            event.stopPropagation();
            return true;
        }
    }
    return <Text {...props} onChange={handleChange} onKeyPress={handleKeyPress} />
}

function Required(props) {
    const errors = props.errors || {};
    let className = props.className || '';
    let label;
    if (errors[props.name]) {
        className += ' error';
        label = <label className={className} htmlFor={props.name} id={`${props.name}-error`}>This field is required.</label>
    }
    return (
        <Text className={className} {...props} required={true}>
            {label}
        </Text>
    );
}

function Text(props) {
    let handleChange;
    if (props.onChange) {
        handleChange = event => props.onChange(props.name, event.currentTarget.value);
    }
    let handleKeyPress = props.onKeyPress;
    if (props.onSubmit) {
        handleKeyPress = (event) => {
            if (props.onKeyPress && props.onKeyPress(event)) {
                // Handled above
                return;
            }
            if (event.which != 13) {
                return;
            }
            event.preventDefault();
            props.onSubmit();
        }
    }
    return (
        <React.Fragment>
            {
                props.type == 'textarea' &&
                <textarea
                    ref={props.onRef}
                    aria-label={props['aria-label'] || props.placeholder}
                    autoComplete={props.autoComplete}
                    className={props.className}
                    cols={props.cols}
                    disabled={props.disabled}
                    id={props.id}
                    name={props.name}
                    placeholder={props.placeholder}
                    rows={props.rows}
                    required={props.required}
                    style={props.style}
                    title={props.placeholder}
                    value={props.value || ''}
                    onBlur={props.onBlur}
                    onChange={handleChange}
                    onFocus={props.onFocus}
                    onKeyPress={handleKeyPress}></textarea>
            }
            {
                props.type != 'textarea' &&
                <input
                    ref={props.onRef}
                    aria-label={props['aria-label'] || props.placeholder}
                    autoComplete={props.autoComplete}
                    className={props.className}
                    disabled={props.disabled}
                    id={props.id}
                    maxLength={props.maxLength}
                    name={props.name}
                    pattern={props.pattern}
                    placeholder={props.placeholder}
                    required={props.required}
                    style={props.style}
                    title={props.placeholder}
                    type={props.type || "text"}
                    value={props.value || ''}
                    onBlur={props.onBlur}
                    onChange={handleChange}
                    onFocus={props.onFocus}
                    onKeyPress={handleKeyPress} />
            }
            {props.children}
        </React.Fragment>
    );
}

function Wrapper(props) {
    let className = 'input input--outl';
    let size;
    switch (props.size) {
        case 'large':
            size = 'lg';
            break;
        case 'medium':
            size = 'md';
            break;
        case 'small':
            size = 'sm';
            break;
    }
    if (size) {
        className += ` input--${size}`;
    }
    if (props.className) {
        className += ` ${props.className}`;
    }
    return (
        <div className={className} style={props.style}>
            {props.children}
        </div>
    );
}

export {
    Numeric,
    Required, 
    Text, 
    Wrapper 
};